import React, { Component } from 'react';
import wx from 'weixin-js-sdk'
import './index.scss';
class rechargeComplete extends Component {
    constructor(props) {
        super(props)
        this.state = {
            telephone: '',
            ticket: '',
            correct: require('../../assets/wancheng.png'),
            userName: '',
            studentNo: '',
        }
    }
    componentDidMount() {
        const searchParams = new URLSearchParams(window.location.search)
        this.setState({
            telephone: searchParams.get('telephone'),
            ticket: searchParams.get('ticket')
        })
        if (searchParams.get('ticket')) {
            this.getDetail(searchParams.get('ticket'))
            window.document.title = '浙师公寓洗澡'
        } else {
            window.document.title = '支付成功'
        }
        console.log('telephone:', searchParams.get('telephone'));
        console.log('ticket:', searchParams.get('ticket'));
    }
    render() {
        const goBack = () => {
            console.log('跳转微信')
            wx.miniProgram.reLaunch({
                url: '../billList/billList'
            })
            return
        }
        return (
            <>
                <div className='recharge-page-box'>
                    <div className='page-content'>
                        <div className='img-box'>
                            <img className='correct' src={this.state.correct} />
                            <div className='size-style'>支付成功</div>
                        </div>
                    </div>
                    <div className='btn-box'>
                        <div className='btn-con' onClick={goBack}>确定</div>
                    </div>
                </div>
            </>
        )
    }
}
export default rechargeComplete;